export enum CacheKeyEnum {
    PAGED_SNIPPET_IN_SLOT_OVERVIEW = 'PAGED_SNIPPET_IN_SLOT_OVERVIEW',
    PAGED_POPUP_OVERVIEW = 'PAGED_POPUP_OVERVIEW',
    POPUP = 'POPUP',
    POPUP_ASSOCIATION = 'POPUP_ASSOCIATION',
    POPUP_VISIBILITY_RULE = 'POPUP_VISIBILITY_RULE',
    POPUP_CODE_TRIGGER = 'POPUP_CODE_TRIGGER',
    POPUP_TIME_DELAY_TRIGGER = 'POPUP_TIME_DELAY_TRIGGER',
    PRODUCT_CATEGORIES_ALL = 'PRODUCT_CATEGORIES_ALL',
    PRODUCTS = 'PRODUCTS',
    PRODUCT_CATEGORIES_TREE = 'PRODUCT_CATEGORIES_TREE',
    PRODUCT_CATEGORIES_MASTER_TREE = 'PRODUCT_CATEGORIES_MASTER_TREE',
    PRODUCT_FEATURE_AUTHORIZATIONS = 'PRODUCT_FEATURE_AUTHORIZATIONS',
    PRODUCT_TRADEMARKS = 'PRODUCT_TRADEMARKS',
    PRODUCT_BRANDS = 'PRODUCT_BRANDS',
    PRODUCT_IMAGE_URL = 'PRODUCT_IMAGE_URL',
    CATALOG_PRODUCT_OVERVIEW = "CATALOG_PRODUCT_OVERVIEW",
    INTERNAL_PRODUCT_CATEGORIES = "INTERNAL_PRODUCT_CATEGORIES",
    MASTER_MAIN_CATEGORIES = "MASTER_MAIN_CATEGORIES",
    NOTIFICATION_TEMPLATES = "NOTIFICATION_TEMPLATES",
    MAILING_MAIL_TEMPLATE = "MAILING_MAIL_TEMPLATE",
    MAILING_MAIL_TEMPLATES = "MAILING_MAIL_TEMPLATES",
    ENUM = "ENUM"
}
